import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { clearAccessToken, refreshAccessToken } from './tokenStore';

type Retriable = InternalAxiosRequestConfig & { _afterRefresh?: boolean };

/** Fired when a refresh fails, so the app can send the user to the login page. */
export const SESSION_EXPIRED_EVENT = 'flahafast:session-expired';

/**
 * On a 401, get a new access token once and repeat the request. Auth endpoints are left alone (a bad
 * password must stay a 401), and a request is retried at most once.
 */
export function installRefreshOn401(instance: AxiosInstance = axios): void {
  instance.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const config = error.config as Retriable | undefined;
      const url = config?.url || '';
      if (error.response?.status !== 401 || !config || config._afterRefresh || url.includes('/auth/')) {
        throw error;
      }
      config._afterRefresh = true;
      try {
        const token = await refreshAccessToken();
        config.headers.Authorization = `Bearer ${token}`;
        return instance.request(config);
      } catch {
        clearAccessToken();
        if (typeof window !== 'undefined') window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
        throw error;
      }
    }
  );
}
